import axios from "axios"
import { API_BASE_URL } from "configs/AppConfig"
import { signOutSuccess } from "store/slices/authSlice"
import store from "../store"
import { AUTH_TOKEN } from "constants/AuthConstant"
import { notification } from "antd"

// Create axios instance
const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
})

service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null

    if (jwtToken) {
      config.headers["Authorization"] = `Bearer ${jwtToken}`
    }

    return config
  },
  (error) => {
    notification.error({
      message: "Error",
    })
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    const status = error?.response?.status
    const message = error?.response?.data?.error || "Erreur inconnue"

    // Affiche la notification uniquement pour certaines erreurs
    if (status === 401) {
      localStorage.removeItem(AUTH_TOKEN)
      store.dispatch(signOutSuccess())
      // const ignoredMessages = ["Old password is incorrect"];
      // if (!ignoredMessages.includes(message)) {
      //   notification.error({ message });
      // }
    }

    return Promise.reject(error)
  }
)

export default service
